import React from 'react';

import {Radio} from 'legacy_components/Radio';
import styles from 'legacy_css_modules/YesNo.module.css';

export const YesNo = ({heading, highlighted,...props}) => {

    return (
        <div>
            <h2 className={styles.heading}>{heading}</h2>
            <div style={{ border: highlighted ? '1px solid var(--red)' : '1px solid white' }} className={styles.inputs}>
                <Radio label="Ano" value="true" {...props}/>
                <Radio label="Ne" value="false" {...props}/>
            </div>
        </div>
    )
}